// validators/package.js
import { sharedValidators } from "./shared";

const packageValidators = {
  // Step 2: Title
  2: ({ step1 }, t) => (!step1.name?.trim() ? t("please_fill_title") : null),

  // Step 3: Package Type
  3: ({ step1 }, t) =>
    !step1.package_type_id ? t("please_select_package_type") : null,

  // Step 4: Location
  4: ({ step1 }, t) => {
    if (!step1.country_id) return t("please_fill_country");
    if (!step1.city_id) return t("please_fill_city");
    if (!step1.phone?.trim()) return t("please_fill_phone");
    if (!step1.address?.trim()) return t("please_fill_address");
    return null;
  },

  // Step 5: Informations (group size)
  5: ({ step1 }, t) => {
    if (!step1.min_adults || step1.min_adults < 1)
      return t("please_fill_min_adults");
    if (!step1.max_adults || step1.max_adults < step1.min_adults)
      return t("please_fill_max_adults");
    return null;
  },

  // Step 6: Host/Guide
  6: ({ step1 }, t) => {
    if (
      step1.has_guide &&
      step1.guide_in_person.length === 0 &&
      step1.guide_audio.length === 0 &&
      step1.guide_information.length === 0
    ) {
      return t("please_select_guide");
    }
    return null;
  },

  // Step 8: Timeline (Date Range)
  8: ({ step2 }, t) => {
    if (!step2.start_date) return t("please_fill_start_date");
    if (!step2.end_date) return t("please_fill_end_date");
    return null;
  },

  // Step 9: Description
  9: ({ step2 }, t) => {
    if (!step2.short_summary?.trim()) return t("please_fill_summary");
    if (step2.short_summary.trim().length < 32) return t("summary_too_short");
    if (!step2.detailed_description?.trim())
      return t("please_fill_description");
    if (step2.detailed_description.trim().length < 60)
      return t("description_too_short");
    return null;
  },

  // Step 10: Inclusions and Restrictions
  10: ({ step2 }, t) => {
    // if (
    //   !step2.included_items ||
    //   step2.included_items.filter((i) => i?.trim()).length === 0
    // )
    //   return t("please_fill_included_items");

    // if (
    //   !step2.excluded_items ||
    //   step2.excluded_items.filter((i) => i?.trim()).length === 0
    // )
    //   return t("please_fill_excluded_items");

    return null;
  },

  //   // Step 11: Keywords
  //   11: ({ step2 }, t) =>
  //     !step2.keyword || step2.keyword.length === 0
  //       ? t("please_select_keywords")
  //       : null,

  // Step 13: Days/Itinerary
  13: ({ step3 }, t) => {
    if (
      !step3.itinerary_days ||
      !Array.isArray(step3.itinerary_days) ||
      step3.itinerary_days.length === 0
    ) {
      return t("please_add_at_least_one_day");
    }

    for (let i = 0; i < step3.itinerary_days.length; i++) {
      const day = step3.itinerary_days[i];
      const dayNum = i + 1;

      // Validate destination
      if (!day.destination?.trim()) {
        return t("day_missing_destination", { dayNum });
      }

      // Validate description
      if (!day.description?.trim()) {
        return t("day_missing_description", { dayNum });
      }

      // Validate accommodation if included
      if (day.is_accommodation_included) {
        const acc = day.accommodation_reference;
        if (!acc.accommodation_type)
          return t("accommodation_missing_type", { dayNum });
        if (!acc.name?.trim())
          return t("accommodation_missing_name", { dayNum });
        if (!acc.address?.trim())
          return t("accommodation_missing_address", { dayNum });
        if (!acc.category)
          return t("accommodation_missing_category", { dayNum });
        if (
          !Array.isArray(acc.product_room_type_id) ||
          acc.product_room_type_id.length === 0
        )
          return t("accommodation_missing_room_type", { dayNum });
      }

      // Validate transport if included
      if (day.is_transport_included) {
        const trans = day.transport_reference;
        if (!trans.transport_type)
          return t("transport_missing_type", { dayNum });
        if (!trans.company_name?.trim())
          return t("transport_missing_company", { dayNum });
        if (!trans.departure_location?.trim())
          return t("transport_missing_departure", { dayNum });
        if (!trans.arrival_location?.trim())
          return t("transport_missing_arrival", { dayNum });
        if (!trans.departure_time)
          return t("transport_missing_departure_time", { dayNum });
        if (!trans.arrival_time)
          return t("transport_missing_arrival_time", { dayNum });
        if (!trans.duration_value || trans.duration_value <= 0)
          return t("transport_missing_duration", { dayNum });
        if (!trans.duration_unit)
          return t("transport_missing_duration_unit", { dayNum });
      }
    }

    return null;
  },

  // Step 15: Policy (Logistics)
  15: ({ step4 }, t) => {
    if (!step4.arrival_time_value || step4.arrival_time_value < 0)
      return t("please_fill_arrival_time");
    if (!step4.cutoff_time_booking_value || step4.cutoff_time_booking_value < 0)
      return t("please_fill_cutoff_time");
    if (!step4.cancellation_policy_id)
      return t("please_fill_cancellation_policy_id");
    if (step4.has_dropoff_location && !step4.dropoff_location?.trim())
      return t("please_fill_dropoff_location");
    if (!step4.meeting_point?.trim()) return t("please_fill_meeting_point");
    return null;
  },

  // Step 16: Booking confirmation
  16: ({ step4 }, t) => {
    if (!step4.booking_confirmation_mode)
      return t("please_fill_booking_confirmation_mode");
    return null;
  },

  // Step 17: Pricing
  17: ({ step4 }, t) => {
    const { pricing } = step4;
    if (!pricing.adult_price || parseFloat(pricing.adult_price) <= 0)
      return t("please_fill_adult_price");
    if (!pricing.child_price) return t("please_fill_child_price");
    if (pricing.child_price && parseFloat(pricing.child_price) < 0)
      return t("child_price_cannot_be_negative");
    if (!pricing.senior_price) return t("please_fill_senior_price");
    if (pricing.senior_price && parseFloat(pricing.senior_price) < 0)
      return t("senior_price_cannot_be_negative");
    if (!pricing.baby_price) return t("please_fill_baby_price");
    if (pricing.baby_price && parseFloat(pricing.baby_price) < 0)
      return t("baby_price_cannot_be_negative");
    return null;
  },

  // Shared validators
  //shared: [sharedValidators.images],
};

export default packageValidators;
